import styles from './Slide.module.scss';
import React, { useRef } from 'react';
import FeaturesButtons from './Buttons/FeaturesButtons';
import FeaturesList from './List/FeaturesList';
import { EffectCreative, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import PrevNextButtons from './PrevNextButtons/PrevNextButtons';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function Slide({ slide, buttonConfig }) {
  const swiperRef = useRef(null);

  // 获取图片URL的函数
  const getImageUrl = (imageItem) => {
    if (imageItem && imageItem.image && imageItem.image.fields) {
      return (
        imageItem.image.fields.desktopImage?.value?.src ||
        imageItem.image.fields.tabletImage?.value?.src ||
        imageItem.image.fields.mobileImage?.value?.src ||
        ''
      );
    }
    return imageItem.image?.url || '';
  };

  const handlePrev = () => {
    swiperRef.current?.slidePrev();
  };

  const handleNext = () => {
    swiperRef.current?.slideNext();
  };

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        grabCursor={true}
        effect={'creative'}
        loop={true}
        speed={800}
        creativeEffect={{
          prev: {
            shadow: false,
            translate: ['-120%', 0, -500],
          },
          next: {
            shadow: false,
            translate: ['120%', 0, -500],
          },
        }}
        modules={[Navigation, EffectCreative]}
        className="mySwiper2"
      >
        {(slide?.images || []).map((item, index) => {
          const imageUrl = getImageUrl(item);
          return (
            <SwiperSlide key={item.id}>
              <div className={styles.slideImage}>
                <Image
                  field={{
                    value: {
                      src: imageUrl,
                      alt: 'Car image',
                      width: 777,
                      height: 429,
                    },
                  }}
                />
              </div>
            </SwiperSlide>
          );
        })}

        {/* PC端导航按钮放在 Swiper 内部 */}
        <div className={styles.navigationButtons}>
          <PrevNextButtons onPrev={handlePrev} onNext={handleNext} />
        </div>
      </Swiper>

      {/* 移动端导航按钮放在 Swiper 外部 */}
      <div className={styles.mobileNavigationButtons}>
        <PrevNextButtons onPrev={handlePrev} onNext={handleNext} />
      </div>

      <FeaturesList slide={slide} />
      <FeaturesButtons slide={slide} comingSoonText={buttonConfig?.comingSoonText} />
    </div>
  );
}
